import React from 'react';
import { I13nAnchor } from 'react-i13n';

import { Button, Link } from '../../common/components/core';
import EmailInput from './EmailInput';
import ScreenResetVerification from './ScreenResetVerification';
import LoggedoutActions from '../../main/actions/LoggedoutActions';
import LoggedoutStore from '../../main/stores/LoggedoutStore';
import { emailValid, inputTooLong } from './ScreenSignupValidation';

export default class ScreenResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = null;
    this.setTextInputRef = element => {
      this.textInput = element;
    };
    this.state = {
      email: null,
      resetSuccess: LoggedoutStore.resetSuccess(),
      errors: {},
      emailChecked: false,
      emailValid: false,
      errorFootnotes: {
        email: null
      }
    };
  }

  componentWillMount() {
    LoggedoutStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    LoggedoutStore.removeChangeListener(this._onChange);
    if (this.form) {
      this.form.removeEventListener('invalid', this._preventDefault, true);
    }
  }

  componentDidMount() {
    LoggedoutActions.clearErrors();
    if (this.form) {
      this.form.addEventListener('invalid', this._preventDefault, true);
    }
  }

  _assignForm = form => {
    this.form = form;
  };

  _onChange = () => {
    const resetSuccess = LoggedoutStore.resetSuccess();
    const errors = LoggedoutStore.getErrors();
    this.setState({ resetSuccess, errors });
  };

  _validateEmail = input => {
    const currentErrors = { ...this.state.errorFootnotes };
    currentErrors.email = !emailValid(input)
      ? 'Please specify a valid email address e.g., myname@email.com.'
      : inputTooLong(input)
      ? 'Please specify a shorter email.'
      : '';
    return {
      errorFootnotes: currentErrors,
      emailValid: emailValid(input),
      emailChecked: true
    };
  };

  _handleEmailChange = ev => {
    const validation = this._validateEmail(ev.value);
    this.setState({
      email: ev.value,
      errorFootnotes: validation.errorFootnotes,
      emailValid: validation.emailValid,
      emailChecked: validation.emailChecked
    });
    LoggedoutActions.clearErrors();
  };

  _preventDefault = ev => {
    ev.preventDefault();
  };

  _sendResetEmail = () => {
    if (!this.state.email) {
      this._renderErrors('email');
      const currentErrors = { ...this.state.errorFootnotes };
      currentErrors.email = !emailValid(this.state.email)
        ? 'Please specify a valid email address e.g., myname@email.com.'
        : '';
      this.setState({
        errorFootnotes: currentErrors,
        emailValid: !!emailValid(this.state.email),
        emailChecked: true
      });
    } else {
      const validation = this._validateEmail(this.state.email);
      if (validation.emailValid) {
        LoggedoutActions.sendResetEmail(this.state.email);
      }
    }
  };

  _onDataChange = key => {
    return ev => {
      this.setState({ [key]: ev.value });
      LoggedoutActions.clearErrors();
    };
  };

  _renderErrors = key => {
    return this.state.errorFootnotes[key]
      ? this.state.errorFootnotes[key]
      : this.state.errors[key];
  };

  _handleTryAgainLink = () => {
    this.setState({
      resetSuccess: false,
      email: null,
      emailChecked: false
    });
  };

  render() {
    const passwordResetScreen = !this.state.resetSuccess
      ? 'show-form h_w-100'
      : 'h_d-n';
    const resetVerificationScreen = this.state.resetSuccess
      ? 'show-form slide-in email-sent'
      : 'h_d-n slide-in';
    const button = !this.state.resetSuccess ? 'btn-signup' : 'h_d-n';
    return (
      <div>
        <div className={passwordResetScreen}>
          <div className="loggedout--container">
            <img src="/static/images/branch-logos/branch-logo_dark.svg" />
            <div className="login-container">
              <div className="reset-header">
                <h1 className="welcome-text h_fw-700">Reset Password</h1>
                <div className="signin-link-container">
                  <Link
                    to="/"
                    className="signin-link"
                    i13nModel={{ label: 'to Sign up page' }}
                    testid="link-to-signup"
                  >
                    <span className="h_fw-400">New user?</span>
                    Create an Account
                  </Link>
                </div>
              </div>
              <form
                role="form"
                id="form_login"
                className="sign-up-form-1 login-form h_mb-10 Bizible-Exclude"
                ref={this._assignForm}
                onSubmit={this._preventDefault}
              >
                <div className="modal-body login-form">
                  <div className="sign-up-container">
                    <div className="sign-up-1">
                      <div className={passwordResetScreen}>
                        <EmailInput
                          onChange={this._handleEmailChange}
                          value={this.state.email}
                          ref={this.setTextInputRef}
                          footnote={this._renderErrors('email')}
                          label="Email address"
                          testid="email-address"
                          className="reset-input"
                          hasError={this._renderErrors('email')}
                          inputChecked={this.state.emailChecked}
                          inputValid={this.state.emailValid}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="loggedout--reset">
                  <Button
                    className={button}
                    onClick={this._sendResetEmail}
                    testid="reset-pw__continue"
                  >
                    Continue
                  </Button>
                </div>
              </form>
              <div className="reset-footer-container">
                <div className="itself-center reset-footer">
                  Questions? We are here to{' '}
                  <I13nAnchor
                    href="https://support.branch.io"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    help
                  </I13nAnchor>
                  .
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={resetVerificationScreen}>
          <ScreenResetVerification
            email={this.state.email}
            onLinkClick={this._handleTryAgainLink}
          />
        </div>
      </div>
    );
  }
}
